export default __webpack_public_path__ + "static/media/honeycomb.17502c65.svg";